import axios from "axios";
import { getCookie } from "../../App";
import { domain } from "../Links/Links";

export async function SignoutRequest(setSignoutButtonStatus) {
  const response = await axios.post(domain + "/signout_api/", {'signout': 'signout'}, {
    withCredentials: true,
    headers: { "X-CSRFToken": getCookie("csrf_token") },
  });

  console.log(response.data)

  if (response.data.ok) {
    setSignoutButtonStatus(false);
    window.location.href = "/";
  }
  
}
